module.exports = __webpack_public_path__ + "static/event-bg-d43782527da3955f41e92bc97833233b.jpg";